document.addEventListener('DOMContentLoaded', function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const grids = document.querySelectorAll('[data-product-grid]');
  if (!grids.length) return;

  const STORAGE_PREFIX = 'collectionInfiniteState';
  const PAGE_KEY = `${STORAGE_PREFIX}:${window.location.pathname}`;
  const RESET_KEY = 'collectionInfiniteState:forceReset';

  let revealObserver;
  let shouldSaveState = true;

  function getPageState() {
    try {
      const raw = sessionStorage.getItem(PAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setPageState(partialState) {
    if (!shouldSaveState) return;

    const prev = getPageState() || {};
    const next = { ...prev, ...partialState };
    sessionStorage.setItem(PAGE_KEY, JSON.stringify(next));
  }

  function clearPageState() {
    sessionStorage.removeItem(PAGE_KEY);
  }

  function forceResetOnNextPageLoad() {
    sessionStorage.setItem(RESET_KEY, 'true');
  }

  function consumeForcedReset() {
    const shouldReset = sessionStorage.getItem(RESET_KEY) === 'true';
    if (shouldReset) {
      sessionStorage.removeItem(RESET_KEY);
      return true;
    }
    return false;
  }

  function saveScrollPosition(currentPage) {
    setPageState({
      path: window.location.pathname,
      page: currentPage,
      scrollY: window.scrollY
    });
  }

  function initReveal(scope) {
    const items = scope.querySelectorAll('.reveal-on-scroll:not(.is-visible)');

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      });
    }

    items.forEach(function (item) {
      revealObserver.observe(item);
    });
  }

  async function fetchPage(url) {
    const response = await fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    const html = await response.text();
    const parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  }

  function buildPageUrl(page) {
    const url = new URL(window.location.href);

    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', page);
    }

    return url.toString();
  }

  grids.forEach(function (grid) {
    let isLoading = false;
    let isRestoring = false;
    let currentPage = 1;
    let loadMoreLink = grid.parentElement.querySelector('[data-load-more-link]');
    let sentinel = grid.parentElement.querySelector('[data-infinite-sentinel]');
    let infiniteObserver;

    initReveal(grid);

    async function appendPage(page) {
      const doc = await fetchPage(buildPageUrl(page));
      const incomingGrid = doc.querySelector('[data-product-grid]');

      if (!incomingGrid) return false;

      const newItems = incomingGrid.querySelectorAll('.collections-all-page__item');

      newItems.forEach(function (item) {
        grid.appendChild(item);
      });

      if (window.initProductCardCart) {
        window.initProductCardCart(grid);
      }

      initReveal(grid);

      const incomingLoadMoreLink = doc.querySelector('[data-load-more-link]');

      if (incomingLoadMoreLink) {
        if (!loadMoreLink) {
          loadMoreLink = incomingLoadMoreLink.cloneNode(true);
        } else {
          loadMoreLink.href = incomingLoadMoreLink.href;
        }
      } else {
        if (loadMoreLink) {
          loadMoreLink.remove();
          loadMoreLink = null;
        }

        if (infiniteObserver && sentinel) {
          infiniteObserver.unobserve(sentinel);
        }
      }

      currentPage = page;
      return true;
    }

    async function loadNextPage() {
      if (isLoading || !loadMoreLink || isRestoring) return;

      isLoading = true;
      document.body.classList.add('is-loading-products');

      try {
        const nextPage = currentPage + 1;
        await appendPage(nextPage);
      } catch (error) {
        console.error('Infinite scroll error:', error);
      } finally {
        isLoading = false;
        document.body.classList.remove('is-loading-products');
      }
    }

    async function restorePageState() {
      const mustResetToTop = consumeForcedReset();

      if (mustResetToTop) {
        clearPageState();

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            window.scrollTo(0, 0);
          });
        });

        return;
      }

      const savedState = getPageState();

      if (!savedState) return;
      if (savedState.path !== window.location.pathname) return;

      const targetPage = parseInt(savedState.page, 10) || 1;
      const targetScrollY = parseInt(savedState.scrollY, 10) || 0;

      if (targetPage <= 1) {
        requestAnimationFrame(function () {
          window.scrollTo(0, targetScrollY);
        });
        return;
      }

      isRestoring = true;
      document.body.classList.add('is-loading-products');

      try {
        for (let page = 2; page <= targetPage; page++) {
          await appendPage(page);
        }

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            window.scrollTo(0, targetScrollY);
          });
        });
      } catch (error) {
        console.error('Restore infinite scroll state error:', error);
      } finally {
        isRestoring = false;
        document.body.classList.remove('is-loading-products');
      }
    }

    if (loadMoreLink && sentinel) {
      infiniteObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      }, {
        rootMargin: '500px 0px'
      });

      infiniteObserver.observe(sentinel);
    }

    document.addEventListener('click', function (event) {
      const link = event.target.closest('a');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      const isSamePageAnchor = href.startsWith('#');
      const isJavascriptLink = href.startsWith('javascript:');
      const isExternal = link.origin && link.origin !== window.location.origin;

      if (isSamePageAnchor || isJavascriptLink || isExternal) return;

      const isMenuNavigation =
        link.closest('.hf__desktop-nav') ||
        link.closest('.hf__mobile-nav') ||
        link.closest('.shop-submenu-section__nav') ||
        link.classList.contains('hf__center');

      if (isMenuNavigation) {
        shouldSaveState = false;
        clearPageState();
        forceResetOnNextPageLoad();
        return;
      }

      const isProductLink =
        link.closest('.collections-all-page__item') ||
        link.closest('.shop-by-look-grid__item');

      if (isProductLink) {
        shouldSaveState = true;
        saveScrollPosition(currentPage);
        return;
      }

      shouldSaveState = false;
      clearPageState();
    });

    window.addEventListener('beforeunload', function () {
      if (!shouldSaveState) return;
    });

    window.addEventListener('pageshow', function () {
      const mustResetToTop = consumeForcedReset();

      if (mustResetToTop) {
        clearPageState();

        requestAnimationFrame(function () {
          window.scrollTo(0, 0);
        });

        return;
      }

      const savedState = getPageState();
      if (!savedState) return;

      requestAnimationFrame(function () {
        window.scrollTo(0, parseInt(savedState.scrollY, 10) || 0);
      });
    });

    restorePageState();
  });
});